/*************************************************/
/* MENU                                          */
/*************************************************/

export function menu() {
    const parentMenuItemSelector = '.menu-nav__item--parent';
    const submenuSelector = '.mega-menu';
    const headerSelector = '.header';
    const activeClass = "active";
    const activeClassHeader = "active-header";
    const parentActiveClass = "active-item";
    let activeSubMenu = null;
    const parentMenuItems = document.querySelectorAll(parentMenuItemSelector);
    const header = document.querySelector(headerSelector);

    const init = () => {

        if (parentMenuItems.length > 0 && header) {
            parentMenuItems.forEach(item => {   
                // Handle click event
                item.addEventListener('click', (event) => {
                    const subMenu = item.querySelector(submenuSelector);
                    if (subMenu) {
                        // Close the currently active submenu (if any) before opening a new one
                        if (activeSubMenu && activeSubMenu !== subMenu) {
                            closeSubMenu(activeSubMenu);
                            parentMenuItems.forEach(item => {
                                item.classList.remove(parentActiveClass);
                            })
                        }

                        if (subMenu.classList.contains(activeClass)) {
                            closeSubMenu(subMenu); // Close if already open
                            parentMenuItems.forEach(item => {
                                item.classList.remove(parentActiveClass);
                            })
                        } else {
                            openSubMenu(subMenu); // Open if not open
                            item.classList.add(parentActiveClass);
                        }
                    } else {
                        if (activeSubMenu) {
                            closeSubMenu(activeSubMenu);
                            parentMenuItems.forEach(item => {
                                item.classList.remove(parentActiveClass);
                            })
                        }
                    }

                    event.stopPropagation(); // Prevent the click from reaching the document
                });

                // Handle Enter key event
                item.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter') {
                        item.click(); // Simulate a click event
                    }
                });
            });

            // Close the submenu when clicking outside
            document.addEventListener('click', (event) => {
                if (activeSubMenu && !header.contains(event.target)) {
                    closeSubMenu(activeSubMenu);
                    parentMenuItems.forEach(item => {
                        item.classList.remove(parentActiveClass);
                    })
                }
            });
        }
    };

    const openSubMenu = (subMenu) => {
        subMenu.setAttribute('aria-hidden', false);
        subMenu.classList.add(activeClass);
        activeSubMenu = subMenu;
        header.classList.add(activeClassHeader);
    };

    const closeSubMenu = (subMenu) => {
        subMenu.setAttribute('aria-hidden', true);
        subMenu.classList.remove(activeClass);
        activeSubMenu = null;
        header.classList.remove(activeClassHeader);
    };

    init();
}
